import { mergeRoutes, sharedRoutes } from '@shared/routes.js'
import { createRouter, createWebHistory } from 'vue-router'
import { addNoIndexTag, removeNoIndexTag } from '@/homepage/utils/noIndexTag.js'
import { useHomepageStore } from '@/stores/homepage.js'
import { useExperimentsStore } from '@shared/stores/experiments'

export const routes = mergeRoutes(sharedRoutes, [
  {
    path: '/',
    component: () => import('@/homepage/views/HomePage.vue'),
    name: 'home'
  },
  {
    path: '/howitworks',
    component: () => import('@/homepage/views/HowItWorks.vue'),
    name: 'how-it-works'
  },
  {
    path: '/frequently-asked-questions',
    component: () => import('@/homepage/views/FaqPage.vue'),
    name: 'frequently-asked-questions'
  },
  {
    path: '/refer/:referralCode',
    component: () => import('@/views/ReferralHome.vue'),
    name: 'refer',
    meta: {
      hidePromoBanner: true,
      noindex: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404' // Shared route.
  }
])

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    const anchor = to.hash ? document.querySelector(to.hash) : null
    if (anchor) {
      const top = parseInt(getComputedStyle(anchor).scrollMarginTop)
      return { el: to.hash, top: isNaN(top) ? 0 : top }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { left: 0, top: 0 }
    }
  }
})

router.beforeEach(async (to, _from) => {
  const hasQueryParams = route => !!Object.keys(route.query).length

  // Capture and store utm campaign attributes
  if (hasQueryParams(to)) {
    /* eslint-disable camelcase */
    const { utm_campaign, utm_source, utm_medium } = to.query
    if (utm_campaign) sessionStorage.setItem('utm_campaign', utm_campaign)
    if (utm_source) sessionStorage.setItem('utm_source', utm_source)
    if (utm_medium) sessionStorage.setItem('utm_medium', utm_medium)
    /* eslint-enable camelcase */
  }

  // Add the noindex meta tag to disable search indexing for routes that request it.
  // Once we've updated to more modern packages, switch to @unhead/vue library.
  const noindex = to.matched.slice().reverse().find(r => r.meta && r.meta.noindex)
  if (noindex) {
    addNoIndexTag()
  } else {
    removeNoIndexTag()
  }

  // TO DO!  Use composable/plugin and call page() function instead of window.analytics directly
  if (typeof window.analytics !== 'undefined') {
    window.analytics.page(to.fullPath)
  }

  useExperimentsStore().untilExperimentsLoaded({ throwOnTimeout: false })
  const homepageStore = useHomepageStore()
  if (!homepageStore.initialDataLoaded) {
    await homepageStore.loadInitialData()
  }
})

export default router
